"use strict";
import {
  formScrollerInit,
  uploadFileOutput,
  submitAfterDisabled,
} from "../../utility/_form";
import { initGuidelineKv } from "../../utility/_modules";

const inputCheckedEvents = () => {
  const checkboxs = document.querySelectorAll('.value input[type="checkbox"]');
  checkboxs.forEach((checkbox) => {
    const parent = checkbox.parentNode;
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        parent.classList.add("is-checked");
      } else {
        parent.classList.remove("is-checked");
      }
    });

    checkbox.addEventListener("focus", () => {
      parent.classList.add("is-focused");
    });

    checkbox.addEventListener("blur", () => {
      parent.classList.remove("is-focused");
    });
  });
};

const errorCheckedEvents = () => {
  const inputAreas = document.querySelectorAll(".form__input, .form__accept");
  inputAreas.forEach((area) => {
    const targetElements = area.querySelector(".wpcf7-not-valid");
    // const targetElements = area.getElementsByClassName("form__error");
    if (targetElements !== null) {
      area.classList.add("is-error");
    }
    // if (targetElements.length > 0) {
    //   area.classList.add("is-error");
    // }
  });
};

const formTopMove = () => {
  const content = document.getElementById("content");
  if (content) {
    window.scrollTo({
      top: content.offsetTop,
    });
  }
};

const receiveData = (e) => {
  if (e.origin === "https://go.ageha.tv") {
    const receivedData = e.data;
    document.querySelector("iframe").style.height = receivedData.height + "px";
    if (receivedData.validate) {
      formTopMove();
    }
  }
};

const wpcf7 = document.querySelector(".wpcf7-form"),
  sales = "https://www.ageha.tv/contact/contact-sales-thanks/",
  partner = "https://www.ageha.tv/contact/contact-partner-thanks/",
  other = "https://www.ageha.tv/contact/contact-other-thanks/",
  thanksPage = {
    // ステージング
    // 21731: sales,
    // 21730: partner,
    // 21728: other,
    // 本番
    22898: sales,
    22897: partner,
    22896: other,
  };

if (wpcf7) {
  wpcf7.addEventListener("wpcf7invalid", () => {
    // ボタンの無効解除
    const submit = document.querySelector('[type="submit"]');
    submit.disabled = false;

    const xhr = new XMLHttpRequest();
    xhr.addEventListener("loadend", () => {
      errorCheckedEvents();
    });
    formTopMove();
  });

  wpcf7.addEventListener(
    "wpcf7mailsent",
    (event) => {
      location = thanksPage[event.detail.contactFormId];
    },
    false
  );
}

window.addEventListener("message", receiveData, false);

window.addEventListener("DOMContentLoaded", () => {
  inputCheckedEvents();
  errorCheckedEvents();
  formScrollerInit();
  uploadFileOutput();
  // submitAfterDisabled();
});

window.addEventListener("load", () => {
  initGuidelineKv();
});
